import { styled } from '../theme';
import Text from './Text';

const FieldHintText = styled(Text.withComponent('span'))(({ theme }) => ({
    fontWeight: theme.typography.fontWeight.roman,
    fontSize: '1.2rem',
}));

export default FieldHintText;
